$("select[name='updates[]']").on("change", function () {
  $("input[name='update']").trigger("click");
});
if ($(".cart-item.remove-insurance")[0]) {
  CartJS.clear();
  setTimeout(function () {
    window.location = window.location.pathname;
  }, 1000);
}

$("select#size").on("change", function () {
  var selectedVariant = $(this).val();
  $(this)
    .parents(".related-item-column")
    .siblings(".add-column")
    .find(".add-button")
    .attr("data-variant", selectedVariant);
});

$("a.add-button").on("click", function () {
  variantId = $(this).attr("data-variant");
  CartJS.addItem(
    variantId,
    1,
    {},
    {
      success: function (data, textStatus, jqXHR) {
        location.reload();
      },

      error: function (jqXHR, textStatus, errorThrown) {
        $(".added-to-cart p.info-bar-link").text(
          "Something went wrong, try again"
        );
        $(".added-to-cart").addClass("show-add");
      },
    }
  );
});

$(document).on("cart.requestComplete", function (event, cart) {
  setTimeout(function () {
    $(".added-to-cart").removeClass("show-add");
  }, 2500);
});
